import { render, staticRenderFns } from "./TeacherResetPass.vue?vue&type=template&id=4da81a04&scoped=true"
import script from "./TeacherResetPass.vue?vue&type=script&lang=js"
export * from "./TeacherResetPass.vue?vue&type=script&lang=js"
import style0 from "./TeacherResetPass.vue?vue&type=style&index=0&id=4da81a04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da81a04",
  null
  
)

export default component.exports